import { Component } from '@angular/core';

@Component({
    selector: 'fuel-app-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.scss']
})
export class ListViewComponent {}
